import { render, staticRenderFns } from "./ApproveLevel2.vue?vue&type=template&id=d5bf8900&scoped=true"
import script from "./ApproveLevel2.vue?vue&type=script&lang=js"
export * from "./ApproveLevel2.vue?vue&type=script&lang=js"
import style0 from "./ApproveLevel2.vue?vue&type=style&index=0&id=d5bf8900&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5bf8900",
  null
  
)

export default component.exports